<template>
	<v-card>
		<v-card-title>
			<h2>Subkonta</h2>
			<v-spacer></v-spacer>
		</v-card-title>

		<slot name="addSubBidderAction"/>

		<v-dialog v-model="deleteDialog" max-width="500">
			<v-card>
				<v-card-title>
					<span class="headline">Czy na pewno chcesz usunąć to subkonto?</span>
				</v-card-title>

				<v-card-text>
					Operacja usunięcia jest nieodwracalna.
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="deleteDialog = false; subBidderToDelete = null">
						Anuluj
					</v-btn>
					<v-btn color="primary" flat
						@click="deleteSubBidder()">
						Usuń
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="editDialog" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline"> Zmiana adresu e-mail </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs10>
								<v-form ref="form">
									<v-text-field
										browser-autocomplete="off"
										data-vv-name="email"
										data-vv-as="E-mail"
										:error-messages="vErrors.collect('email')"
										label="E-mail"
										aria-label="email"
										for="subbider-table-email"
										id="subbider-table-email"
										v-model="editedItem.email"
										v-validate="'required|email'"
										data-vv-validate-on="none"
									></v-text-field>
								</v-form>
							</v-flex>
							<v-flex xs2 style="display: flex; align-items: center; justify-content: center;">
								<v-tooltip bottom max-width="480px">
									<template v-slot:activator="{ on }">
										<v-icon color="primary" dark v-on="on">info</v-icon>
									</template>
									<span>
										Pozostałe dane subkonta może edytować jego użytkownik
									</span>
								</v-tooltip>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="editDialog = false">
						Anuluj
					</v-btn>
					<v-btn color="primary" flat @click="save" v-if="editedItem.email">
						Zapisz
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-layout align-center justify-center row>
			<v-flex xs2>
				<v-text-field
					class="ma-2"
					browser-autocomplete="off"
					v-model="dataTable.searchFields.name"
					label="Imię"
					aria-label="name"
					for="sub-bidder-table-name"
					id="sub-bidder-table-name"/>
			</v-flex>
			<v-flex xs3>
				<v-text-field
					class="ma-2"
					browser-autocomplete="off"
					v-model="dataTable.searchFields.surname"
					label="Nazwisko"
					aria-label="surname"
					for="sub-bidder-table-surname"
					id="sub-bidder-table-surname"/>
			</v-flex>
			<v-flex xs3>
				<v-autocomplete
					class="ma-2"
					v-model="dataTable.searchFields.subBidderType"
					:items="subBidderTypeList"
					item-text="name"
					item-value="value"
					label="Typ subkonta"
					clearable
					aria-label="sub bidder type"
					for="sub-bidder-table-sub-bidder-type"
					id="sub-bidder-table-sub-bidder-type"
				></v-autocomplete>
			</v-flex>
		</v-layout>
		<v-layout align-center justify-center row>
			<v-flex xs4>
				<v-text-field
					class="ma-2"
					browser-autocomplete="off"
					v-model="dataTable.searchFields.email"
					label="E-mail"
					aria-label="email"
					for="sub-bidder-table-email"
					id="sub-bidder-table-email"/>
			</v-flex>
			<v-flex xs4>
				<v-layout align-center justify-center>
					<v-btn @click="buildNewSearch" color="primary" dark class="mb-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="mb-2">Resetuj</v-btn>
					<v-btn @click="exportData" color="primary" dark class="mb-2">Eksportuj</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:pagination.sync="dataTable.pagination"
			:total-items="dataTable.itemCount">
			<template slot="items" slot-scope="props">
				<td>{{ props.item.name }}</td>
				<td>{{ props.item.surname }}</td>
				<td>{{ props.item.phoneNumber }}</td>
				<td>{{ props.item.email }}</td>
				<td>{{ props.item.polishName }}</td>
				<td>{{ props.item.type }}</td>
				<td>{{ props.item.status}}</td>
				<td>
					<v-layout row v-if="readOnly">
						<egranty-icon-button
							small
							icon="person"
							label="Profil"
							@click="showProfile(props.item)"
						></egranty-icon-button>
					</v-layout>
					<v-layout row v-else>
						<template v-if="props.item.editable">
							<egranty-icon-button
								small
								icon="edit"
								label="Edytuj"
								@click="editSubBidder(props.item)"
							></egranty-icon-button>
							<egranty-icon-button
								small
								v-if="props.item.status === false"
								icon="email"
								label="Ponownie wyślij wiadomość rejestracyjną"
								@click="resendVerificationMessage(props.item.id)"
							></egranty-icon-button>
							<egranty-icon-button
								small
								icon="delete"
								label="Usuń"
								color="lightred"
								@click="deleteDialog = true; subBidderToDelete = props.item"
							></egranty-icon-button>
						</template>
						<template v-else>
							<v-tooltip bottom max-width="480px">
									<template v-slot:activator="{ on }">
										<v-icon class="ml-2" color="primary" dark v-on="on">info</v-icon>
									</template>
									<span>
										Adres e-mail tego subkonta może zmienić administrator konta danej jednostki podległej. Pozostałe dane subkonta może edytować jego użytkownik.
									</span>
								</v-tooltip>
						</template>
					</v-layout>
				</td>
			</template>
		</v-data-table>

		<egranty-error-list-popup
			title="Błąd usunięcia subkonta"
			:error-list="deleteErrorPopup.messages"
			:is-open="deleteErrorPopup.showPopup"
			@close="closeDeleteErrorPopup"
		/>
	</v-card>
</template>

<script>
import {Api} from "@/api";
import {SubBidder} from "@/api/generated/SubBidder";
import {Pagination} from "@/utils/PaginationUtils";
import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
import EgrantyErrorListPopup from "../../../../genericComponents/EgrantyErrorListPopup";
import {encoder} from "@/utils/encodeHelper";
import {Filters} from "@/utils/Filters";
import {UserRegister} from "@/api/generated/UserRegister";
import {ExportUtils} from "@/utils/ExportUtils";

  export default {
		name: "SubBiddersTable",

		components: {EgrantyIconButton, EgrantyErrorListPopup},

    mixins: [Filters],

		data() {
			return {
				dataTable: {
					searchFields: Pagination.initSearchedFields([
						"name", "surname", "email", "subBidderType", "bidderId",
					]),
					tableHeaders: [
						{text: "Imię", value: "name", sortable: true},
						{text: "Nazwisko", value: "surname", sortable: true},
						{text: "Numer telefonu", value: "phoneNumber", sortable: true},
						{text: "E-mail", value: "email", sortable: true},
						{text: "Polska nazwa podmiotu", value: "polishName", sortable: true},
						{text: "Typ subkonta", value: "type", sortable: true},
						{text: "Status", value: "status", sortable: true},
						{text: "Akcje", value: "action", sortable: false},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25
					},
					search: "",
				},
				editDialog: false,
				deleteDialog: false,
        emailToBeChanged: "",
				subBidderToDelete: null,
				showDuplicateNameMessage: false,
				editedItem: {},
				editedIndex: -1,
        subBidderTypeList: [],
				deleteErrorPopup: {
					showPopup: false,
					messages: [],
				},
			};
		},

    props: {
        readOnly: {type: Boolean, default: false}
    },

    mounted() {
      this.prepareSubBidderTypeFilter();
      this.dataTable.searchFields = this.retrieveFilters(this.dataTable.searchFields);
      this.dataTable.pagination = this.retrievePagination(this.dataTable.pagination);
      this.buildNewSearch();
    },

		watch: {
			editDialog(val) {
        if (!val) {
          this.editedIndex = -1;
          this.editedItem = {};
          this.emailToBeChanged = "";
        }
				this.discardDuplicateNameError();
			},
			"dataTable.pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			},
		},

		methods: {
			discardDuplicateNameError() {
				this.showDuplicateNameMessage = false;
			},

			save() {
				this.$validator.validateAll().then((result) => {
					if (!result) {
						return;
					}
					if (this.emailToBeChanged === this.editedItem.email) {
						this.$messagesBus.$emit("error", "Podany adres e-mail jest identyczny z obecnym");
						return;
					}
          UserRegister.postChangeEmail(this, encoder.encodeUrlParam(this.emailToBeChanged), encoder.encodeUrlParam(this.editedItem.email), successResponse => {
            this.editDialog = false;
            this.$messagesBus.$emit("success", "Adres e-mail został pomyślnie zapisany", successResponse);
            this.getItemList();
            }, errorResponse => {
            this.$messagesBus.$emit("error", errorResponse.status === "NOT_ACCEPTABLE" ?
                errorResponse.message : "Nie udało się zapisać adresu e-mail", errorResponse);
          });
				});
			},

			deleteSubBidder() {
				SubBidder.delete(this, this.subBidderToDelete.id, successResponse => {
          this.subBidderToDelete = null;
          this.deleteDialog = false;
					this.getItemList();
          this.$messagesBus.$emit("success", "Subkonto zostało pomyślnie usunięte", successResponse);
        }, errorResponse => {
			if(errorResponse && errorResponse.message){
				this.deleteErrorPopup.messages = [errorResponse.message];
				this.deleteErrorPopup.showPopup = true;
		  return;
			}
          this.$messagesBus.$emit("error", "Nie udało się usunąć subkonta", errorResponse);
        });
			},

      editSubBidder(item) {
        this.emailToBeChanged = item.email;
        this.editedIndex = this.dataTable.itemList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.editDialog = true;
      },

      showProfile(item) {
        if (this.roles.isAdministrator() || this.roles.isLocalAdministrator()) {
          this.$router.push("/app/profile/" + item.id);
        } else {
          this.$router.openInNewTab({name: "profileView", params: {userId: item.id}});
        }
      },

			resendVerificationMessage (id) {
				SubBidder.postResendVerificationEmail(this, id, successResponse => {
					this.$messagesBus.$emit("success", "Wiadomość z linkiem rejestracyjnym została pomyślnie wysłana", successResponse);
				}, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się wysłać wiadomości z linkiem rejestracyjnym", errorResponse);
        });
			},

			buildSort() {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			getItemList() {
				let sort = this.buildSort();
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				Api.get(this, "/sub-bidder/list?search=" + this.dataTable.search
            + "&page=" + this.dataTable.pagination.page
            + "&result=" + this.dataTable.pagination.rowsPerPage
            + "&sort=".concat(sort),
            successResponse => {
          this.dataTable.itemList = successResponse.itemList;
          this.dataTable.itemCount = successResponse.itemCount;
          },
        errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się pobrać listy suboferentów", errorResponse);
        });
			},

			buildNewSearch() {
				this.dataTable.search = this.buildSearch();
        if (this.$route.params.bidderId) {
          this.dataTable.searchFields.bidderId = this.$route.params.bidderId;
        } else {
          this.dataTable.searchFields.bidderId = undefined;
        }
				this.getItemList();
			},

			resetSearch() {
				Pagination.resetSearch(this.dataTable.searchFields);
        if (this.$route.params.bidderId) {
          this.dataTable.searchFields.bidderId = this.$route.params.bidderId;
        } else {
          this.dataTable.searchFields.bidderId = undefined;
        }
				this.getItemList();
			},

			buildSearch() {
				return Pagination.buildSearchCriteria(this.dataTable.searchFields, false);
			},

      exportData() {
        let search = this.dataTable.search;
        let sort = this.buildSort();
        let path = "/sub-bidder/export?search=" + search + "&sort=".concat(sort);
        ExportUtils.sendExportRequest(path, this);
      },

      prepareSubBidderTypeFilter() {
        if (this.roles.isBidder() || this.roles.isSubBidder()) {
          SubBidder.getSubBidderTypeFilter(this, successResponse => {
            this.subBidderTypeList = successResponse;
          }, errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się pobrać listy typów subkont", errorResponse);
          });
        } else if (this.roles.isAdministrator() || this.roles.isLocalAdministrator() || this.roles.isDepartmentEmployee()) {
          SubBidder.getSubBidderTypeFilterById(this, this.$route.params.bidderId, successResponse => {
            this.subBidderTypeList = successResponse;
          }, errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się pobrać listy typów subkont", errorResponse);
          });
        }
      },

      closeDeleteErrorPopup() {
        this.deleteErrorPopup.showPopup = false;
      },
		},
	};
</script>

<style scoped>

</style>
